import { useCallback, useState } from 'react'

export const useInputFillAnimation = () => {
  const [isAnimating, setIsAnimating] = useState(false)

  const triggerAnimation = useCallback(() => {
    setIsAnimating(false)

    requestAnimationFrame(() => {
      setIsAnimating(true)
    })
  }, [])

  const handleAnimationEnd = useCallback(() => {
    setIsAnimating(false)
  }, [])

  return {
    isAnimating,
    triggerAnimation,
    handleAnimationEnd
  }
}
